<template>
  <a-layout-content class="progress-content">
    <a-spin size="large" :spinning="pageLoading">
      <div style="min-height: 100vh">
        <div v-if="problem">
          <div style="position: relative">
            <problem-header :problem="problem"></problem-header>
      <!--       <p class="date-txt" v-if="problem">
              İlkin müraciət tarixi : {{ problem.appealDate }}
              <a-icon type="clock-circle" style="margin-right: 7px" />
            </p> -->

            <div
              style="position: absolute;  right: 15px"
              class="custom__button__"
            >
                 <a-button
                    v-if="
                      (problem.privilege.selectParentOffice === 'REQUIRED' ||
                      problem.privilege.selectParentOffice === 'OPTIONAL') &&
                      !problem.dateCompleted
                    "
                    @click="addOfficeDetail"
                    style="margin-right: 10px"
                  >
                 Qurum əlavə et
                  </a-button>

                     <a-button

                style="margin-right: 5px"

                  v-if="
                    problem &&
                    problem.privilege &&
                    problem.privilege.selectRepresentation
                  "
                  @click="repModalVis = true"
                  >Məsul əməkdaş təyin et
                </a-button>
              <a-button
                v-if="currentStep.canConsider"
                style="margin-right: 5px"
                @click="handleOpenConsiderationModal"
              >
                {{ attention ? "Nəzarətdən çıxar" : "Nəzarətə al" }}
              </a-button>

              <a-button
                :disabled="isRequestRead"
                style="margin-right: 5px"
                @click="handleSetRequestRead"
              >
                {{ isRequestRead ? "Baxılıb" : "Baxdım" }}
              </a-button>

              <a-button
                style="margin-right: 5px"
                @click="handleShareDrawerOpen"
              >
                Göndər
              </a-button>

              <a-badge :count="commentCount" dot>
                <a-button @click="handleDrawerOpen">Rəylər</a-button>
              </a-badge>
            </div>
          </div>
          <a-row>
            <a-col span="24">
              <div style="float: right">
                <!--  <a-button v-if="problem.files.length>0" type="primary" style="margin: 0 10px 20px 0px;" icon="youtube" @click="showMediaDialog(problem)">Şikayət media faylları</a-button> -->

              </div>
            </a-col>
          </a-row>
          <a-tooltip title="Geri">
            <button class="btn-back">
              <img
                src="../../../assets/imgs/return.png"
                class="back-img"
                @click="goBack"
              />
            </button>
          </a-tooltip>

          <div v-if="problem && problem.executive" class="problems__address">

            <span v-if="problem.address">{{ problem.address }}</span>
          </div>

            <div
        v-if="getCategoriesOfProblem.length > 0"
        style="  align-items: center; margin: 0px 0px 20px 0px"
      >
        <p
          style="
            margin-right: 15px;
            font-size: 19px;
            margin-bottom: 0;
            font-weight: bold !important;
          "
        >
          Müraciətin təsnifatı:
        </p>
        <category-modal @afterClose="handleCategoryModalClose" />
        <div style="display: flex; flex-wrap: wrap;">
          <a-tag
            v-for="(category, idx) in getCategoriesOfProblem"
            :key="`${category.uuid}-${idx}`"
            :color="(category && category.checkedVersion) ? 'rgb(0 152 136 / 78%)' : '#108ee9'"
            style="display: flex; align-items: center; font-size: 15px; margin-top:4px;  white-space: break-spaces;"
          >
            {{ category.name }}
            {{ category.parent ? `(${category.parent.name})` : "" }}
          </a-tag>
        </div>

      </div>
          <g-map
            class="this__map"
            style="width: 100%"
            :latitude="problem.latitude"
            :longitude="problem.longitude"
            :height="500"
          ></g-map>
          <p
            v-if="
              problem &&
              problem.officeDetails &&
              problem.officeDetails.length == 0
            "
          >
            Şikayətə digər təşkilat əlavə edilməyib
          </p>

          <!---General operations if no officedetail-->

          <a-tabs
          class="tab__custom"
            v-if="
              problem &&
              problem.officeDetails &&
              problem.officeDetails.length > 0
            "
            :defaultActiveKey="0"
            v-model="tabKey"
            @change="handleTabChange"
          >
            <a-tab-pane
              v-for="(detailOffice, index) in problem.officeDetails"
              :key="'office' + index"
            >
              <div v-if="detailOffice.category" style="font-size: 14px">
                Müraciətin təsnifatı:
                <span :style="{ color: (detailOffice && detailOffice.checkedVersion) ? '#009888' : '' }">
                  {{ detailOffice.category.name }}
                  <template v-if="detailOffice.category.parentId && detailOffice.category.parentId.name">
                    - {{ detailOffice.category.parentId.name }}
                  </template>
                </span>
              </div>
              <div
                slot="tab"
                style="border-radius: 5px 5px 0px 0px"
                :class="{
                  colorflashing:
                    detailOffice.repCanAssesst || detailOffice.citCanAssest,
                }"
              >
                <a-tooltip :title="getIconTooltipTitle(detailOffice)">
                  <a-icon :type="getIconType(detailOffice)" />{{
                    getTabHeader(detailOffice)
                  }}
                </a-tooltip>
                <!-- <div style="text-align: center;"> period</div> -->
              </div>

              <!--Executor table here-->
              <executor-table
                :dataSource="detailOffice.executeDetails"
                v-if="type != 'ASSESTMENT'"
              ></executor-table>

              <!---Operations table here-->
              <operations-table :dataSource="detailOffice.operations" />



<h2 style="   text-align: center;
    margin: 21px auto;
    width: 270px;
    border-bottom: 1px solid lightgray;">Rəy üçün göndərilənlər</h2>
  <a-table
    :columns="columns"
    :rowKey="(record) => record.id"
    :dataSource="problem.assignments4Comments"
    :pagination="pagination"
     :locale="mylocale"
    class="video-list"
    size="middle"
    >
      <template slot="user" slot-scope="record">
      {{ record.addedUser.firstName +  " "+ record.addedUser.lastName + " " + record.addedUser.fatherName}}
    </template>
       <template slot="fromComment" slot-scope="record">
      {{ record.fromStructure.name }}
    </template>
       <template slot="toComment" slot-scope="record">
      {{ record.toStructure.name }}
    </template>
   <template slot="comment" slot-scope="record">
      {{ record.comment }}
    </template>



  </a-table>
              <!--Numayendeliyin qiymetlendirmeleri burada olacaq -->
            </a-tab-pane>
          </a-tabs>

          <!--    <div style="margin-top: 10px">
            <h2 style="text-align: center">Təkrar müraciətlər</h2>

            <a-tree :tree-data="[problem]" :replace-fields="replaceFields"> -->
          <!-- <span slot="title" slot-scope="item">{{item}}</span> -->
          <!--     </a-tree>
          </div> -->

          <citizen-details v-if="problem" :dataSource="applicants" />

          <!--media dialog-->
          <a-modal
            title="Müraciətə əlavə olunmuş fayllar"
            v-model="mediaDialogVis"
            :footer="null"
            :width="980"
            centered
          >
            <conditional-media :filesList="files" />
          </a-modal>

          <!--Assestment dialog-->
          <assestment-modal
            :visible="assetmentModalVis"
            :selectedDOffice="selectedDetailOffice"
            @afterClose="handleAssestmentModalClose"
            @save="handleAssestmentSave"
          ></assestment-modal>

          <!--Representation modal-->
          <representation-modal
            :visible="repModalVis"
            :problem="problem"
            @afterClose="handleRepAfterClose"
            @change="handleRepChange"
          ></representation-modal>

          <!-- <result-problems v-if="type!='ASSESTMENT'"></result-problems> -->
        </div>

        <not-found-problem v-if="resNotFound"></not-found-problem>

        <!-- Modal for taking into consideration (Nəzarətə almaq) -->
        <a-modal
          title="Müraciəti nəzarətə götürmək"
          centered
          v-model="considerationModalVisible"
          width="35%"
          :footer="null"
        >
          <div
            style="display: flex; align-items: center; flex-direction: column"
          >
            <a-date-picker
              @change="handleConsiderationDateChange"
              placeholder="Bildiriş tarixini seçin"
              showTime
              :disabled-date="disabledDate"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            />

            <div style="margin-top: 15px">
              <a-button
                :disabled="!considerationDate"
                @click="handleSetConsideration"
              >
                {{ attention ? "Nəzarətdən çıxar" : "Nəzarətə götür" }}
              </a-button>
            </div>
          </div>
        </a-modal>

        <!-- Side Drawer for Comments -->
        <a-drawer
          title="Rəylər"
          placement="right"
          :closable="false"
          :visible="drawerVisible"
          @close="handleDrawerClose"
          width="370"
        >
          <div
            v-if="problem && problem.privilege && problem.privilege.canComment"
            style="
              margin-bottom: 20px;
              border-bottom: 1px solid #e8e8e8;
              padding-bottom: 10px;
            "
          >
          <div class="custom_text_area">
            <a-textarea
              :rows="4"
              :maxLength="300"
              v-model="commentText"
              allow-clear
            />
          </div>


            <div
              style="display: flex; justify-content: flex-end; margin-top: 10px"
            >
              <a-button @click="handleSendComment" :loading="addCommentLoading">
                Göndər
              </a-button>
            </div>
          </div>

          <a-list
            item-layout="horizontal"
            :data-source="comments"
            :locale="{ emptyText: 'Rəy yoxdur' }"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta :description="item.dateStr">
                <div slot="title">
                  <div
                    style="
                      font-weight: bold !important;
                      font-size: 17px;
                      margin-bottom: 10px;
                      overflow-wrap: anywhere;
                    "
                  >
                    {{ item.text }}
                  </div>
                  <div>
                    {{ item.opUser.lastName }} {{ item.opUser.firstName }},
                    {{ item.opUser.fatherName }} ({{ item.step }})
                  </div>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-drawer>

        <!-- Side Drawer for Shares -->
      <div   >
          <a-drawer
         ref="leftRef"
          v-if="shareDrawerVisible"
          title=""
          placement="right"
          :closable="false"
          :visible="shareDrawerVisible"
          @close="handleShareDrawerClose"
          width="370"
        >
          <div

            style="
              margin-bottom: 20px;
              border-bottom: 1px solid #e8e8e8;
              padding-bottom: 10px;
            "
          >
       <span class="REQUIRED">Qeyd:</span>
            <a-textarea
           style="display:inline-block"
            id="text"
              :rows="4"
              :maxLength="300"
              v-model="shareText"
              allow-clear
            />
            <!-- upload file -->
            <MyFileUpload
              ref="fileUploadCR"
              @upload-change="myFileUploadData"
              :max="5"
            />

            <!--   <a-upload
    name="file"
    :multiple="true"
    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
    :headers="headers"
    @change="handleChange"
  >
    <a-button> <a-icon type="upload" /> Fayl seçin. </a-button>
  </a-upload> -->

            <div style="margin-top: 10px">
              <p
                style="
                  padding: 5px;
                  background: rgb(47 108 184);
                  color: white;
                  border-radius: 4px;

                "
                v-if="unSelect"
              >
                {{ choosedPerson.firstName }} {{ choosedPerson.lastName }}
                {{ choosedPerson.fatherName }}
                <span
                @click="handleUnSelect"
                  style="
                    margin-left: 9px;
                    padding: 5px 7px;
                    cursor: pointer;
                    background: #de1010;
                    border-radius: 4px;
                  "
                  >x</span
                >
              </p>
              <a-select
                v-if="unSelect === false"
                v-model="shareEmployeeUUIDs"
                show-search
                style="width: 100%"
                placeholder="Əməkdaş seçin"
                @search="onEmployeeSearch"
                @change="onEmployeeChange"
                @blur="handleEmployeeBlue"
                allowClear
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                mode="multiple"
              >
                <!-- <template slot="dataSource"> -->
                <a-select-option
                  :key="employee.uuid"
                  v-for="employee in shareEmployeeList"
                >
                  {{ employee.firstName }} {{ employee.lastName }},
                  {{ employee.fatherName }}
                </a-select-option>
                <!-- </template> -->
              </a-select>
            </div>

            <div
              style="display: flex; justify-content: flex-end; margin-top: 10px"
            >
              <a-button @click="handleShare" :loading="shareLoading">
                {{unSelect?'Cavabla':'Paylaş'}}
              </a-button>
            </div>
          </div>

          <a-list
            item-layout="horizontal"
            :data-source="sharesByMe"
            :locale="{ emptyText: '' }"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              style="
                background-color: #f0f0f035;
                padding: 4px 8px;
                margin-bottom: 5px;
                border-radius: 6px;
                position: relative;
              "
            >
              <a-list-item-meta :description="getDateFormat(item.date)">
                <div slot="title">
                  <div
                    style="
                      font-weight: bold !important;
                      font-size: 17px;
                      margin-bottom: 10px;
                    "
                  >
                  <p style=" overflow-wrap: anywhere; margin-top:25px"> {{ item.message }}</p>

                  </div>
                  <div style="margin-bottom: 10px">
                    {{ item.sender.lastName }} {{ item.sender.firstName }},
                    {{ item.sender.fatherName }}
                  </div>

                  <div
                    style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      border-radius: 50%;
                      background-color: #34c75926;
                      height: 28px;
                      width: 28px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <a-icon
                      type="arrow-up"
                      style="color: #34c759; font-size: 18px"
                      rotate="45"
                    />
                  </div>

                  <div>
                    <a-tag
                      v-for="(reciever, index) in item.receivers"
                      :key="index"
                    >
                      {{ reciever.lastName }} {{ reciever.firstName }},
                      {{ reciever.fatherName }}
                    </a-tag>
                  </div>
                    <a-button size="small" v-if="item.files &&item.files.length>0" @click="showMediaFiles(item.files)">Fayllara bax</a-button>
                </div>


              </a-list-item-meta>
            </a-list-item>


          </a-list>

          <a-list
            v-if="sharesWithMe.length > 0"
            item-layout="horizontal"
            :data-source="sharesWithMe"
            :locale="{ emptyText: '' }"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              style="
                background-color: #f0f0f035;
                padding: 4px 8px;
                margin-bottom: 5px;
                border-radius: 6px;
                position: relative;
              "
            >
              <a-list-item-meta :description="getDateFormat(item.date)">
                <div slot="title">
                  <div
                    style="
                      font-weight: bold !important;
                      font-size: 17px;
                      margin-bottom: 10px;
                    "
                  >
                    {{ item.message }}
                  </div>
                  <div class="withName"
                    style="margin-bottom: 10px; cursor:pointer; transition:.2s"
                    @click="onEmployeeChangeByClick(item.sender)"
                  >
                   <label for="text" style="cursor:pointer;">
                      {{ item.sender.lastName }} {{ item.sender.firstName }},
                    {{ item.sender.fatherName }}
                   </label>
                  </div>

                  <div
                    style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      border-radius: 50%;
                      background-color: #ffcc0026;
                      height: 28px;
                      width: 28px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <a-icon
                      type="arrow-up"
                      style="color: #ffcc00; font-size: 18px"
                      rotate="225"
                    />
                  </div>

                  <div>
                    <a-tag
                      v-for="(reciever, index) in item.receivers"
                      :key="index"
                    >
                      {{ reciever.lastName }} {{ reciever.firstName }},
                      {{ reciever.fatherName }}
                    </a-tag>
                  </div>
                  <a-button size="small" v-if="item.files &&item.files.length>0" @click="showMediaFiles(item.files)">Fayllara bax</a-button>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-drawer>
      </div>
      </div>
    </a-spin>

    <!-- <a-spin :spinning="pageLoading" >
  <a-icon slot="indicator" type="loading" style="font-size: 104px" spin />
</a-spin> -->
      <AddOfficeModal
          v-if="problem"
          :problem="problem"
          :privilege="problem.privilege"
          :visible="opDetailVisibility"
           @afterClose="handleAddOffModalClose"
        />
  </a-layout-content>


</template>

<script>
import { URL, apiCall } from "@/utils/api";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import CategoryModal from "@/components/partials/CategoryModal/index";
import ExecutorTable from "@/components/partials/ExecutorTable/index";
import OperationsTable from "@/components/partials/OperationsTable/index";
import Assestment from "@/components/partials/Assestment/index";
import AssestmentModal from "@/components/pages/Modals/AssestmentModal/index";
import CitizenList from "@/components/partials/CitizenList/index";
import ResultProblemsList from "@/components/partials/ResultProblemsList/index";
import mixin from "@/mixins/index";
import RepresentationModal from "@/components/pages/Modals/RepresentationModal/index";
import NotFoundProblem from "@/components/partials/NotFoundProblem";
import ProblemHeader from "@/components/partials/ProblemHeader/index";
import Map from "@/components/partials/Map/index";
import AssestmentItem from "@/components/partials/AssestmentItem/index";
import AppealItem from "@/components/partials/AppealItem/index";
import CitizenDetails from "@/components/partials/CitizenDetails/index";
import MyFileUpload from "@/components/partials/MyFileUpload/index";
import { format } from "date-fns";
import { az } from "date-fns/locale";
import moment from "moment";
import AddOfficeModal from "@/components/pages/Modals/AddOfficeModal/index";

export default {
  name: "Progress",
  mixins: [mixin],
  props: { type: String },
  components: {
    "conditional-media": ConditionalMedia,
    "category-modal": CategoryModal,
    "executor-table": ExecutorTable,
    "operations-table": OperationsTable,
    asestments: Assestment,
    "assestment-modal": AssestmentModal,
    "citizen-list": CitizenList,
    "result-problems": ResultProblemsList,
    "representation-modal": RepresentationModal,
    "not-found-problem": NotFoundProblem,
    "problem-header": ProblemHeader,
    "g-map": Map,
    "assestment-item": AssestmentItem,
    "appeal-item": AppealItem,
    "citizen-details": CitizenDetails,
    MyFileUpload: MyFileUpload,
    AddOfficeModal
  },
  data() {
    return {
      problem: null,
      mediaDialogVis: false,
      assestmentFilesModalVis: false,
      files: [],
      selectedDetailOffice: null,
      assetmentModalVis: false,
      tabKey: "office0",
      submitLoading: false,
      fileList: [],
      representations: [],
      repModalVis: false,
      selectedRepresentationId: null,
      representationNote: null,
      citizenListType: null,
      selectedRdOffice: null,
      resNotFound: false,
      pageLoading: false,
      refresh: null,
      applicants: [],
      commentText: "",
      addCommentLoading: false,
      shareModalOpen: false,
      comments: [],
      sharesWithMe: [],
      sharesByMe: [],
      drawerVisible: false,
      shareDrawerVisible: false,
      considerationModalVisible: false,
      shareText: "",
      shareLoading: false,
      filePrefix: URL[process.env.NODE_ENV].file_url,
      shareEmployeeList: [],
      shareEmployeeUUIDs: [],
      considerationDate: undefined,
      attention: false,
      commentCount: 0,
      isRequestRead: false,
      myFile: null,
      unSelect: false,
      choosedPerson: null,
      opDetailVisibility:false,
      replaceFields: {
        children: "parent",
        title: "title",
      },
      mylocale: { emptyText: "Məlumat yoxdur" },
           pagination: {
        pageSize: 10,
        current: 1,

        size: "small",

      },
      columns : [

        {
          title: "İstifadəçilər",
          width: "20%",
          scopedSlots: { customRender: "user" },
          align: "center",
        },
        {
          title: " Rəy bildirilən",
          scopedSlots: { customRender: "fromComment" },
          width: "15%",
          align: "center",
        },
           {
          title: "Rəy bildirən ",
          scopedSlots: { customRender: "toComment" },
          width: "15%",
          align: "center",
        },
             {
          title: "Rəy",
          scopedSlots: { customRender: "comment" },
          width: "15%",
          align: "center",
        },



      ],
    };
  },
  methods: {
        addOfficeDetail(parenToffice) {
      this.problem.selectedPOffice = parenToffice;
      this.opDetailVisibility = true;

    },
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf("day");
    },
    // attachment

    myFileUploadData(param) {
      this.myFile = param;
    },
showMediaFiles(item){
 this.shareDrawerVisible=false
this.files  = item
 this.mediaDialogVis=true
},
    goBack() {
      clearInterval(this.refresh);
      this.$router.push("/main");
    },
    convertToLocalDateString(d) {
      return format(d, "d MMMM yyyy, HH:MM", { locale: az });
    },
     handleAddOffModalClose() {
      this.opDetailVisibility = false;
    },
    handleOpenShareModal() {
      this.shareModalOpen = true;
    },
    handleOpenConsiderationModal() {
      if (!this.attention) {
        this.considerationModalVisible = true;
        return;
      }
      this.handleSetConsideration();
    },
    handleDrawerClose() {
      this.drawerVisible = false;
    },
    handleDrawerOpen() {
      this.drawerVisible = true;
    },

    handleShareDrawerClose() {
      this.shareDrawerVisible = false;
    },
    handleShareDrawerOpen() {
      this.shareDrawerVisible = true;
    },

    handleConsiderationDateChange(_date, dateString) {
      this.considerationDate = dateString;
    },

    async handleGetConsideration() {
      const baseURL = URL[process.env.NODE_ENV].service_api;
      const uuid = this.$route.params.id;
      const url = `${baseURL}problems/${uuid}/monitoring`;

      try {
        const res = await apiCall({ url });

        this.attention = res.data.data;
      } catch (_error) {}
    },

    async handleSetRequestRead() {
      const baseURL = URL[process.env.NODE_ENV].service_api;
      const uuid = this.$route.params.id;
      const url = `${baseURL}problems/${uuid}/shown?seen=true`;

      try {
        await apiCall({ url, method: "POST" });
        this.isRequestRead = true;
        this.$message.success("Müraciətə baxıldı.");
      } catch (_error) {}
    },

    async handleSetConsideration() {
      const baseURL = URL[process.env.NODE_ENV].service_api;
      const uuid = this.$route.params.id;
      const date = this.considerationDate;
      const url = `${baseURL}problems/${uuid}/monitoring?attention=${!this
        .attention}${this.attention?"":'&attentionDate='+date}`;

      try {
        await apiCall({ url, method: "POST" });
        this.$message.success(
          this.attention
            ? "Müraciət nəzarətdən çıxarıldı"
            : "Müraciət nəzarətə götürüldü"
        );
        this.considerationDate = undefined;
        this.considerationModalVisible = false;
        this.handleGetConsideration();
      } catch (_error) {}
    },

    async getIsRequestRead(uuid) {
      const url = `${
        URL[process.env.NODE_ENV].service_api
      }problems/${uuid}/shown`;

      try {
        const res = await apiCall({ url });
        this.isRequestRead = res.data.data;
      } catch (_error) {}
    },

    async onEmployeeSearch(searchText) {
      if (!searchText) return;

      const url = `${
        URL[process.env.NODE_ENV].auth_api
      }users/searching/${searchText}`;

      try {
        const res = await apiCall({ url });
        console.log(res);
        this.shareEmployeeList = res.data.data;
      } catch (_error) {}
    },
    onEmployeeChange(shareEmployees) {
      this.shareEmployeeUUIDs = shareEmployees;
    },
    onEmployeeChangeByClick(param) {
            this.shareEmployeeUUIDs = [param.uuid];
      this.unSelect = true;
      this.choosedPerson = param;
  /*    this.$refs.leftRef.scrollIntoView(true); */
    },
    handleUnSelect(){
      this.shareEmployeeUUIDs=[];
      this.unSelect = false;
      this.choosedPerson = null;
    },
    handleEmployeeBlue() {
      this.shareEmployeeList = [];
    },
    async handleSendComment() {
      if (!this.commentText) return;

      this.addCommentLoading = true;
      const serviceAPI = URL[process.env.NODE_ENV].service_api;
      const id = this.$route.params.id;
      const url = `${serviceAPI}problems/${id}/comments`;
      const data = { text: this.commentText };

      try {
      let res =  await apiCall({ url, method: "POST", data });
        if(res.data.error){
         this.$message.error(res.data.error.message);
        }
        else{
 /*  this.$message.success("Rəy göndərildi"); */
        }

        this.commentText = "";
        this.addCommentLoading = false;
        this.getComments();
      } catch (_error) {
        this.addCommentLoading = false;
      }
    },
    async handleShare() {
      if (!this.shareText.trim() || this.shareEmployeeUUIDs.length === 0) return;

      const serviceAPI = URL[process.env.NODE_ENV].service_api;
      const id = this.$route.params.id;
      const url = `${serviceAPI}problems/${id}/sharings`;
      const data = {
        message: this.shareText,
        receiverUUIDs: this.shareEmployeeUUIDs,
        files: this.myFile,
      };

      try {
        await apiCall({ url, method: "POST", data });
        this.$message.success("Müraciət göndərildi.");
        this.shareText = "";
        this.shareEmployeeUUIDs = [];
        this.shareModalOpen = false;
        this.shareLoading = false;
        this.getShares();
        this.myFile = null;
      } catch (_error) {
        this.shareLoading = false;
      }
      this.shareDrawerVisible = false;
      this.unSelect=false;
      this.choosedPerson=null;
    },
    async getComments() {
      const serviceAPI = URL[process.env.NODE_ENV].service_api;
      const id = this.$route.params.id;
      const url = `${serviceAPI}problems/${id}/comments`;

      try {
        const res = await apiCall({ url, method: "GET" });
        this.comments = res.data.data.reverse();
        this.commentCount = this.comments.length;
      } catch (_error) {}
    },
    async getShares() {
      const serviceAPI = URL[process.env.NODE_ENV].service_api;
      const id = this.$route.params.id;
      const url = `${serviceAPI}problems/${id}/sharings/detail`;

      try {
        const res = await apiCall({ url, method: "GET" });
        this.sharesByMe = res.data.data["SharedByMe"]?.reverse();
        this.sharesWithMe = res.data.data["SharedByOthers"]?.reverse();
      } catch (_error) {}
    },

    getDateFormat(d) {
      return new Date(d).toLocaleString("az-AZ");
    },

    handleTabChange(key) {
      const idx = key.replace("office", "");
      this.selectedRdOffice = this.problem.officeDetails[idx];
    },
    handleUploadChange({ fileList }) {
      this.fileList = fileList;
    },

    getHeader() {
      if (!this.problem.executive) return "";
      return this.problem.representation
        ? this.problem.representation.name +
            " (" +
            this.problem.executive.name +
            ")"
        : this.problem.executive.name;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },

    handleAppealSelChange(appeal) {
      this.selectedAppeal = appeal;
    },
    handleAssestmentSave() {
      this.selectedDetailOffice.canAssess = false;
      this.assetmentModalVis = false;
      this.getProblemDetails();
    },
    addAssestment(detail, detailOffice) {
      this.selectedDetailOffice = detailOffice;
      this.assetmentModalVis = true;
    },
    handleAssestmentModalClose() {
      this.assetmentModalVis = false;
    },
    handleCategoryModalClose() {
      this.getProblemDetails();
    },
    handleRepAfterClose() {
      this.repModalVis = false;
    },
    showMediaDialog(detail) {
      this.files = detail.files;
      if (!this.files || this.files.length === 0) {
        this.$message.warning("Media fayl yoxdur");
        return;
      }
      this.mediaDialogVis = true;
    },
    handleRepChange(rep) {
      this.problem.representation = rep;
      this.repModalVis = false;
    },
    getIconTooltipTitle(officeDetail) {
      return officeDetail.repCanAssesst || officeDetail.citCanAssest
        ? "Qiymətləndirmə aktivdir"
        : "";
    },
    getIconType(officeDetail) {
      return officeDetail.repCanAssesst || officeDetail.citCanAssest
        ? "star"
        : "solution";
    },
    getProblemDetails() {
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.$route.params.id,
        method: "GET",
        params: {
          all: true,
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.problem = response.data.data;
            this.$set(
              this.problem,
              "headerTxt",
              "Şikayət № " +
                this.problem.number.pad(6) +
                " (" +
                this.problem.appealCount +
                " dəfə müraciət olunub)"
            );

            this.problem.officeDetails.forEach((officeDetail) => {
              officeDetail.operations = officeDetail.operations
                .concat(this.problem.operations)
                .sort((a, b) => {
                  return b.id - a.id;
                });
            });

            this.getProblemApplicants();
          } else if (response.data.error.code === 1080) {
            this.$message.error(response.data.error.message);
            this.resNotFound = true;
          } else this.$message.error(response.data.error.message);
          this.pageLoading = false;
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
          this.pageLoading = false;
        });
    },
  },



  computed: {
       getCategoriesOfProblem: function () {
      const categories = this.problem ? this.problem.categories : [];
      return categories;
    },
    treeData() {
      if (!this.problem) return [];

      return [this.problem].map((p) => ({ ...p, children: p.parent }));
    },
  },
  watch: {
    "$route.params.id": function (id) {
      this.pageLoading = true;
      this.getProblemDetails({ detailed: true });
      this.getComments();
      this.getShares();
      this.getIsRequestRead(id);
      this.handleGetConsideration();
    },
  },
  async created() {
    this.pageLoading = true;
    this.citizenListType = this.type === "ASSESTMENT" ? this.type : null;
    this.getProblemDetails();
    this.getProblemApplicants();
    this.getComments();
    this.getShares();
    this.getIsRequestRead(this.$route.params.id);
    this.handleGetConsideration();
  },
};
</script>
<style >
.withName:hover{
  background-color:rgba(255, 204, 0, 0.15);
}
.custom_text_area .ant-input-affix-wrapper.ant-input-affix-wrapper-textarea-with-clear-btn .ant-input{
padding-right: 32px !important;
}
.custom_text_area i {
  right: 12px !important
}
</style>
<style lang="scss" scoped src="./index.scss"></style>
